import { Types } from '../../types';

/**
 * @description 判断值的类型，建议用输出值和数据类型枚举Types比较
 * @param any
 * @returns 类型名称 Types as string
 */
const getType = (any: any): Types => {
  const typeString = Object.prototype.toString.call(any);
  switch (typeString) {
    case '[object Object]':
      return Types.Object;
    case '[object Array]':
      return Types.Array;
    case '[object String]':
      return Types.String;
    case '[object Function]':
      return Types.Function;
    case '[object Number]':
      return Types.Number;
    case '[object Undefined]':
      return Types.Undefined;
    case '[object Null]':
      return Types.Null;
    case '[object Symbol]':
      return Types.Symbol;
    case '[object BigInt]':
      return Types.BigInt;
    case '[object Map]':
      return Types.Map;
    case '[object Set]':
      return Types.Set;
    case '[object ReadableStream]':
      return Types.ReadableStream;
    case '[object FileReader]':
      return Types.FileReader;
    case '[object Blob]':
      return Types.Blob;
    case '[object HTMLDocument]':
      return Types.HTMLDocument;
    case '[object Window]':
      return Types.Window;
    case '[object Request]':
      return Types.Request;
    case '[object Response]':
      return Types.Response;
    default:
      return Types.Unknown;
  }
};

export default getType;
